import React from 'react';
import { Spinner } from 'ui';

const Loading = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="d-f fd-c ai-c">
        <Spinner />
        <div className="ta-c w-fill mt-8">
          {t('lessons.editor.element_assistant.loading')}
        </div>
      </div>
    );
  }
  return children;
};

export default Loading;
